import {platform} from "@/api/platform";
import {retryRequest} from "@/helpers/request";
import emitter, {EVENTS} from "@/api/events";

export default {
    namespaced: true,
    state: {
        loading: false,
        type: null
    },
    getters: {
        loading: state => state.loading,
        type: state => JSON.parse(JSON.stringify(state.type))
    },
    mutations: {
        setLoading: (state, loading) => state.loading = loading,
        setType: (state, type) => state.type = type,
    },
    actions: {
        fetch(context) {

            context.commit("setLoading", true);

            return retryRequest(() => platform.get(`/api/v2/user/${this.getters["user/id"]}/constraints`))
                .then(response => {

                    context.commit("setType", response.data.results.constraints.type);
                    context.commit("setLoading", false);

                    emitter.emit(EVENTS.USER_CONSTRAINTS_FETCH);
                });
        },
        clear(context) {

            context.commit("setType", null);
        }
    }
}